/* Matchstick Monkey Australia — shared theme behaviour.
   Colour/product/character DATA now comes from Liquid (real Shopify
   products, collections and metafields) rendered server-side into each
   section's markup — this file only supplies interaction, not content. */

document.addEventListener('DOMContentLoaded', () => {

/* ---- mega menu open state (hover intent + touch) ---- */
document.querySelectorAll('.nav-item').forEach(item => {
  if (!item.querySelector('.mega')) return;
  let t;
  item.addEventListener('mouseenter', () => {
    clearTimeout(t);
    document.querySelectorAll('.nav-item.open').forEach(o => o !== item && o.classList.remove('open'));
    item.classList.add('open');
  });
  item.addEventListener('mouseleave', () => { t = setTimeout(() => item.classList.remove('open'), 160); });
});

/* ---- mobile drawer ---- */
const drawer = document.getElementById('mm-drawer'), burger = document.querySelector('.burger');
if (drawer && burger) {
  const setOpen = o => { document.body.classList.toggle('drawer-open', o); drawer.setAttribute('aria-hidden', String(!o)); burger.setAttribute('aria-expanded', String(o)); if (o) drawer.querySelector('.drawer-close').focus(); else burger.focus(); };
  burger.addEventListener('click', () => setOpen(true));
  drawer.querySelector('.drawer-close').addEventListener('click', () => setOpen(false));
  drawer.querySelectorAll('a[href^="#"]').forEach(a => a.addEventListener('click', () => setOpen(false)));
  document.addEventListener('keydown', e => { if (e.key === 'Escape' && document.body.classList.contains('drawer-open')) setOpen(false); });
}


/* ---- policy pages: wrap Shopify's bare policy markup in the site design ---- */
const pol = document.querySelector('.shopify-policy__container');
if (pol) {
  const path = location.pathname.replace(/\/$/, '');
  const links = [['Shipping','/policies/shipping-policy'],['Returns','/policies/refund-policy'],['Privacy','/policies/privacy-policy'],['Terms','/policies/terms-of-service']];
  const title = pol.querySelector('.shopify-policy__title');
  const body = pol.querySelector('.shopify-policy__body');
  const kicker = document.createElement('p'); kicker.className = 'policy-kicker'; kicker.textContent = 'Help & legal';
  title.prepend(kicker);
  const nav = document.createElement('nav'); nav.className = 'policy-nav'; nav.setAttribute('aria-label','Policies');
  links.forEach(([t,u]) => { const a = document.createElement('a'); a.href = u; a.textContent = t; if (path.endsWith(u)) a.classList.add('on'); nav.appendChild(a); });
  title.after(nav);
  const facts = { 'shipping-policy': [['Free over $50','Standard shipping Australia-wide, otherwise $12.95'],['Melbourne','Dispatched by Coolkidz Australia'],['1300 722 302','Talk to a real person']],
                  'refund-policy': [['Wrong or faulty?','We will make it right, fast'],['Unopened items','See the returns terms below'],['1300 722 302','Talk to a real person']] };
  const f = facts[path.split('/').pop()];
  if (f) { const g = document.createElement('div'); g.className = 'policy-facts'; f.forEach(([b,s]) => { const d = document.createElement('div'); d.innerHTML = '<b></b><span></span>'; d.querySelector('b').textContent = b; d.querySelector('span').textContent = s; g.appendChild(d); }); nav.after(g); }
  /* numbered clauses (1.1, 2.3 ...) get a hanging number */
  body.querySelectorAll('.rte > p').forEach(p => { const m = p.textContent.match(/^\s*(\d+\.\d+)\s+/); if (m && p.children.length === 0) { p.classList.add('clause'); p.innerHTML = '<b class="num">' + m[1] + '</b>' + p.innerHTML.replace(/^(?:\s|&nbsp;)*\d+\.\d+(?:\s|&nbsp;)*/, ''); } });
  /* contents column for long policies */
  const h2s = [...body.querySelectorAll('.rte h2')];
  const grid = document.createElement('div'); grid.className = 'policy-grid';
  body.before(grid);
  if (h2s.length >= 4) {
    grid.classList.add('has-toc');
    const toc = document.createElement('aside'); toc.className = 'policy-toc'; toc.innerHTML = '<h5>On this page</h5>';
    h2s.forEach((h, i) => { h.id = h.id || 'section-' + (i + 1); const a = document.createElement('a'); a.href = '#' + h.id; a.textContent = h.textContent.trim(); toc.appendChild(a); });
    grid.appendChild(toc);
  }
  grid.appendChild(body);
  const help = document.createElement('div'); help.className = 'policy-help';
  help.innerHTML = '<div><h3>Need a hand?</h3><p>Questions about an order, a delivery or a return? The Coolkidz Australia team answers within one business day.</p></div><a class="btn btn-dark" href="/pages/contact">Contact us →</a>';
  const monkey = document.querySelector('.walker img'); if (monkey) { const im = document.createElement('img'); im.src = monkey.src; im.alt = ''; im.setAttribute('aria-hidden','true'); help.appendChild(im); }
  pol.appendChild(help);
}


/* ---- keep the header cart badge current (after ajax adds, back/forward cache, etc.) ---- */
const badge = document.querySelectorAll('[data-cart-count]');
if (badge.length) {
  const setCount = n => badge.forEach(b => { b.textContent = n; b.hidden = !n; });
  const refresh = () => fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(r => r.json()).then(c => setCount(c.item_count)).catch(() => {});
  window.addEventListener('pageshow', e => { if (e.persisted) refresh(); });
  document.addEventListener('cart:updated', refresh);
}


/* ---- flip cards: tap toggles on touch, hover on desktop ---- */
document.querySelectorAll('.story-card.flip').forEach(card => {
  card.addEventListener('click', () => { if (matchMedia('(hover: none)').matches) card.classList.toggle('on'); });
  card.addEventListener('keydown', e => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); card.classList.toggle('on'); } });
});


/* ---- quick add (ajax) ---- */
document.addEventListener('click', async e => {
  const btn = e.target.closest('[data-quick-add]'); if (!btn) return;
  e.preventDefault();
  if (btn.classList.contains('is-busy')) return;
  btn.classList.add('is-busy');
  try {
    const r = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: Number(btn.dataset.quickAdd), quantity: 1 }] }) });
    if (!r.ok) throw new Error('add failed');
    btn.classList.remove('is-busy'); btn.classList.add('is-added');
    document.dispatchEvent(new CustomEvent('cart:updated'));
    setTimeout(() => btn.classList.remove('is-added'), 1800);
  } catch (err) {
    btn.classList.remove('is-busy');
    const link = btn.closest('.gang-card')?.querySelector('.gc-link'); if (link) location.href = link.href;
  }
});

/* ---- scroll reveal + stagger + zoom ---- */
document.querySelectorAll('.reveal-kids').forEach(c => [...c.children].forEach((k,i) => k.style.setProperty('--i', i)));
const io = new IntersectionObserver(es => es.forEach(e => {
  if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
}), { threshold: .1 });
document.querySelectorAll('.reveal,.reveal-kids,.zoom-reveal').forEach(el => io.observe(el));

/* ---- parallax ---- */
const plxEls = [...document.querySelectorAll('.plx-img')];
const noMotion = matchMedia('(prefers-reduced-motion: reduce)');
let plxTick = false;
function doPlx() {
  const vh = innerHeight;
  plxEls.forEach(el => {
    const r = el.parentElement.getBoundingClientRect();
    if (r.bottom < 0 || r.top > vh) return;
    const f = parseFloat(el.dataset.plx || '-0.08');
    const off = (r.top + r.height / 2 - vh / 2) * f;
    el.style.transform = `translate3d(0,${off.toFixed(1)}px,0) scale(1.16)`;
  });
  plxTick = false;
}
addEventListener('scroll', () => { if (!plxTick && !noMotion.matches) { plxTick = true; requestAnimationFrame(doPlx); } }, { passive: true });
if (!noMotion.matches) doPlx();

/* ---- PDP: gallery thumbs + quantity stepper (only present on product pages) ---- */
const gMain = document.getElementById('gMain');
if (gMain) {
  document.querySelectorAll('.g-thumbs button').forEach(b => b.onclick = () => {
    gMain.style.opacity = 0;
    setTimeout(() => { gMain.src = b.dataset.src; gMain.onload = () => gMain.style.opacity = 1; }, 150);
    document.querySelectorAll('.g-thumbs button').forEach(x => x.classList.remove('on'));
    b.classList.add('on');
  });
}
const qMinus = document.getElementById('qMinus'), qPlus = document.getElementById('qPlus');
if (qMinus && qPlus) {
  let qty = 1;
  const qEl = document.getElementById('qtyVal');
  const qtyInput = document.getElementById('qtyInput');
  function syncQty() { qEl.textContent = qty; if (qtyInput) qtyInput.value = qty; }
  qMinus.onclick = () => { qty = Math.max(1, qty - 1); syncQty(); };
  qPlus.onclick = () => { qty = Math.min(9, qty + 1); syncQty(); };
}

/* ---- monkey match quiz (only present on the homepage) ---- */
const quizRoot = document.getElementById('mmQuiz');
if (quizRoot) {
  const ans = {};
  let step = 0;
  const steps = [...quizRoot.querySelectorAll('.q-step')];
  const dots = [...quizRoot.querySelectorAll('.q-dot')];
  const resultGroups = quizRoot.querySelectorAll('[data-result-for]');
  function goto(n) {
    step = n;
    steps.forEach(s => s.classList.toggle('on', +s.dataset.step === n));
    dots.forEach((d,i) => d.classList.toggle('on', i <= Math.min(n,2)));
    if (n === 3) renderResult();
  }
  quizRoot.querySelectorAll('.q-opt').forEach(b => b.onclick = () => { ans[b.dataset.q] = b.dataset.v; goto(step + 1); });
  const restartBtn = quizRoot.querySelector('#qRestart');
  if (restartBtn) restartBtn.onclick = () => goto(0);
  function renderResult() {
    let key = 'gift';
    if (ans.need === 'gums') key = ans.vibe === 'animal' ? 'gums-animal' : ans.vibe === 'soft' ? 'gums-soft' : 'gums-bright';
    else if (ans.need === 'teeth') key = ans.vibe === 'soft' ? 'teeth-soft' : ans.vibe === 'animal' ? 'teeth-animal' : 'teeth-bright';
    else if (ans.need === 'bath') key = 'bath';
    else key = ans.vibe === 'soft' ? 'gift-soft' : ans.vibe === 'animal' ? 'gift-animal' : 'gift-bright';
    resultGroups.forEach(g => g.hidden = g.dataset.resultFor !== key);
    quizRoot.querySelectorAll('[data-why-for]').forEach(w => w.hidden = w.dataset.whyFor !== key);
  }
}

/* ---- colour lab (homepage) ---- */
const labSwatches = document.getElementById('swatches');
if (labSwatches) {
  const buttons = [...labSwatches.querySelectorAll('.sw')];
  const labImg = document.getElementById('labImg'), labName = document.getElementById('labName'),
        labPrice = document.getElementById('labPrice'), labBuy = document.getElementById('labBuy');
  function pick(i) {
    const b = buttons[i];
    if (labImg) { labImg.classList.add('fading'); setTimeout(() => { labImg.src = b.dataset.img; labImg.onload = () => labImg.classList.remove('fading'); }, 180); }
    if (labName) labName.textContent = b.dataset.name;
    if (labPrice) labPrice.textContent = b.dataset.price;
    if (labBuy) labBuy.href = b.dataset.url;
    buttons.forEach((x,j) => x.classList.toggle('on', j === i));
  }
  buttons.forEach((b,i) => b.addEventListener('click', () => pick(i)));
}

});
